import { Column, ColumnStore } from '@bryntum/grid';
import {$t} from "../../i18Instance";

/**
 * Beschreibt den aktuellen Status des Equipments generell
 */
export class RmsObjectsGridColumnCurrentStatus extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'currentStatusColumn';
    }

    // Override default values
    static get defaults() {
        return {
            field: 'status',
            align: 'center',
            cellCls: 'custom-cell-image',
            editor: false,
            htmlEncode: false,
            filterable: {
                filterField: {
                    type        : 'combo',
                    multiSelect : false,
                    editable    : false,
                    field       : 'status',
                    // Todo: Sollte Dynamisch geladen werden
                    items       : [
                        {text:"Verfügbar",  value: 1},
                        {text:"Versand",    value: 2},
                        {text:"Vermietet",  value: 3},
                        {text:"Service",    value: 4},
                        {text:"Gesperrt",   value: 5}
                    ]
                },
            },
            tooltipRenderer : ({ record, value }) => {
                switch (value){
                    case 1: // Verfügbar
                        return "<div>" + $t('requests.grid.available') + "</div>";
                        break;

                    case 2: // Versand
                        return "<div>" + $t('requests.grid.shipping') + "</div>";
                        break;

                    case 3: // Vermietet
                        return "<div>" + $t('requests.grid.in-rent') + "</div>";
                        break;

                    case 4: // Service
                        return "<div>" + $t('requests.grid.in-service') + "</div>";
                        break;

                    case 5: // Gesperrt
                        return "<div>" + $t('requests.grid.not-available') + "</div>";
                        break

                    default: // Verfügbar
                        return "<div>" + $t('requests.grid.available') + "</div>";
                        break;

                }
            }
        };
    }

    renderer({ record, value }) {
        switch (value){
            case 1: // Verfügbar
                return '<i class="fad fa-circle fa-2x" style="color: green;"></i>';
                break;

            case 2: // Versand
                return '<i class="fad fa-circle fa-2x" style="color: yellow;"></i>';
                break;

            case 3: // Vermietet
                return '<i class="fad fa-circle fa-2x" style="color: red;"></i>';
                break;

            case 4: // Service
                return '<i class="fad fa-circle fa-2x" style="color: yellow;"></i>';
                break;

            case 5: // Gesperrt
                return '<i class="fad fa-circle fa-2x" style="color: red;"></i>';
                break

            default: // Verfügbar
                return '<i class="fad fa-circle fa-2x" style="color: green;"></i>';
                break;

        }
    }
};

ColumnStore.registerColumnType(RmsObjectsGridColumnCurrentStatus);
